// extracted by mini-css-extract-plugin
module.exports = {"menu-view__title":"t_bd my-2 p-2","menu-view__tile-row":"t_bf d-flex"};